import froppioHead from "@/assets/froppio-head.svg";
import type { SetupDetails } from "../types/paymentMethodTypes";
import { CardSetupFacts } from "./CardSetupFacts";

/** Green Froppio header with a card illustration; on large screens it becomes a left rail. */
export function CardSetupHero({ details, title = "Save your card", showCard = true }: {
  details?: SetupDetails; title?: string; showCard?: boolean;
}) {
  const withCard = showCard && !!details;
  return (
    <aside className="lg:flex lg:min-h-full lg:flex-col lg:gap-6 lg:bg-primary lg:px-9 lg:py-10 lg:text-primary-foreground">
      <header className={`rounded-b-[32px] bg-primary px-5 pt-[calc(env(safe-area-inset-top)+1.25rem)] text-primary-foreground lg:rounded-none lg:p-0 ${withCard ? "pb-[72px]" : "pb-6"}`}>
        <div className="flex items-center justify-between gap-3">
          <span className="flex items-center gap-2 text-base font-bold">
            <img src={froppioHead} width={32} height={24} alt="" className="h-6 w-8" />
            Froppio
          </span>
          {details?.environment === "test" && (
            <span className="rounded-full bg-warning-foreground px-2.5 py-1 text-xs font-semibold text-warning">
              Test mode · use test cards
            </span>
          )}
        </div>
        <h1 className="mt-5 text-2xl font-bold leading-tight">{title}</h1>
        {details && (
          <p data-telemetry-mask className="mt-0.5 text-sm text-primary-foreground/85">
            for {details.businessName} · {details.customerName}
          </p>
        )}
      </header>
      {withCard && <>
        <div aria-hidden data-telemetry-mask
          className="relative mx-5 -mt-14 h-48 overflow-hidden rounded-[22px] bg-linear-to-br from-matcha to-[#a7d97a] p-5 text-foreground shadow-[0_14px_28px_rgb(40_96_62/0.25)] lg:mx-0 lg:mt-0">
          <span className="absolute -right-6 -top-6 size-36 rounded-full bg-white/40" />
          <img src={froppioHead} width={72} height={54} alt="" className="absolute right-4 top-4 h-[54px] w-[72px]" />
          <span className="block h-7 w-10 rounded-md bg-linear-to-br from-[#f6e7a7] to-[#d9be5c]" />
          <p className="mt-7 font-mono text-xl tracking-[0.14em]">•••• •••• •••• ••••</p>
          <p className="mt-4 flex justify-between gap-3 text-xs uppercase tracking-wider">
            <span className="truncate">{details.customerName}</span><span>MM/YY</span>
          </p>
        </div>
        <CardSetupFacts businessName={details.businessName} />
      </>}
    </aside>
  );
}
